export const sequence = [];

function run(result) {
    if (sequence.length) {
        const asyncJob = sequence.shift();
        return asyncJob()
            .then(run)
            .catch(e => {
                // clear the queue and dispatch the error
                // empty the array
                sequence.splice(0, sequence.length);
                return Promise.reject(e);
            });
    }

    return Promise.resolve(result);
}

/**
 * Concatenate multiple promises
 * @param promises
 * @returns {*}
 */
export default function promisesSequencer(...promises) {
    sequence.push(...promises);
    return run();
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/misc/promises-sequencer.js